import commonConstant from '../../common/_commonConstant';

export const buildingParkingFeeModelCar = (state, action) => {
  switch (action.type) {
    case commonConstant.SET_BUILDING_PARKING_FEE_MODEL_CAR_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SSET_BUILDING_PARKING_FEE_MODEL_CAR_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const buildingParkingFeeModelMotorcycle = (state, action) => {
  switch (action.type) {
    case commonConstant.SET_BUILDING_PARKING_FEE_MODEL_MOTORCYCLE_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SSET_BUILDING_PARKING_FEE_MODEL_MOTORCYCLE_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const buildingInformation = (state, action) => {
  switch (action.type) {
    case commonConstant.SET_BUILDING_INFORMATION_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SET_BUILDING_INFORMATION_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const redemptionModelInformation = (state, action) => {
  switch (action.type) {
    case commonConstant.SET_REDEMPTION_MODEL_INFORMATION_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SET_REDEMPTION_MODEL_INFORMATION_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const configCommon = (state, action) => {
  switch (action.type) {
    case commonConstant.SET_CONFIG_COMMON_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SET_CONFIG_COMMON_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const config = (state, action) => {
  switch (action.type) {
    case commonConstant.SET_CONFIG_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SET_CONFIG_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const buildingContent = (state, action) => {
  switch (action.type) {
    case commonConstant.SET_BUILDING_CONTENT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SET_BUILDING_CONTENT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const buildingTenant = (state, action) => {
  switch (action.type) {
    case commonConstant.SET_BUILDING_TENANT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SET_BUILDING_TENANT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const buildingIotDevice = (state, action) => {
  switch (action.type) {
    case commonConstant.SET_BUILDING_BUILDING_IOT_DEVICE_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SET_BUILDING_BUILDING_IOT_DEVICE_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const buildingParkingDayConfig = (state, action) => {
  switch (action.type) {
    case commonConstant.SET_BUILDING_PARKING_DAY_CONFIG_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SET_BUILDING_PARKING_DAY_CONFIG_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const currentBuildingDataPath = (state, action) => {
  switch (action.type) {
    case commonConstant.SET_CURRENT_BUILDING_DATA_PATH_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SET_CURRENT_BUILDING_DATA_PATH_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};
